import "./App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import TagManager from "./google-tag/tagmanager";
const HomePage = lazy(() => import("./components/HomePage"));
const StepTwo = lazy(() => import("./components/StepTwo"));
const PLXS = lazy(() => import("./components/plxs/HomePLXSPage"));
const ThankYouFailed = lazy(() => import("./components/ThankYouFailed"));
const ThankYouSuccess = lazy(() => import("./components/ThankYouSuccess"));
const ThankYouSuccessXSTU = lazy(
  () => import("./components/ThankYouSuccessXSTU")
);

const ThankYouPLXSFailed = lazy(
  () => import("./components/plxs/ThankYouFailed")
);

const ThankYouPLXSSuccessXSTU = lazy(
  () => import("./components/plxs/ThankYouSuccessXSTU")
);

export interface accountType {
  name: string;
  nationalId: string;
  phone: string;
}

function App() {
  return (
    <>
      {/* UAT */}
      {/* <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vay-tien-mat-2" element={<HomePage />} />
          <Route path="/vay-tien-mat-buoc-2" element={<StepTwo />} />
          <Route path="/vay-them-tien-chang-muon-phien" element={<PLXS />} />
          <Route
            path="/cam-on-dang-ky-vay-khong-thanh-cong"
            element={<ThankYouFailed />}
          />
          <Route
            path="/vay-them-tien-chang-muon-phien/cam-on-dang-ky-vay-khong-thanh-cong"
            element={<ThankYouPLXSFailed />}
          />
          <Route
            path="/cam-on-dang-ky-vay-thanh-cong-plntb"
            element={<ThankYouSuccess />}
          />
          <Route
            path="/cam-on-dang-ky-vay-thanh-cong-xstu"
            element={<ThankYouSuccessXSTU />}
          />
          <Route
            path="/vay-them-tien-chang-muon-phien/cam-on-dang-ky-vay-thanh-cong-xstu"
            element={<ThankYouPLXSSuccessXSTU />}
          />
        </Routes>
      </Suspense> */}
      {/* PROD */}
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vay-tien-mat-2" element={<HomePage />} />
          <Route path="/vay-tien-mat-buoc-2" element={<StepTwo />} />
          <Route path="/vay-them-tien-chang-muon-phien" element={<PLXS />} />
          <Route
            path="/cam-on-dang-ky-vay-khong-thanh-cong"
            element={<ThankYouFailed />}
          />
          <Route
            path="/vay-them-tien-chang-muon-phien/cam-on-dang-ky-vay-khong-thanh-cong"
            element={<ThankYouPLXSFailed />}
          />
          <Route
            path="/cam-on-dang-ky-vay-thanh-cong-plntb"
            element={<ThankYouSuccess />}
          />
          <Route
            path="/cam-on-dang-ky-vay-thanh-cong-xstu"
            element={<ThankYouSuccessXSTU />}
          />
          <Route
            path="/vay-them-tien-chang-muon-phien/cam-on-dang-ky-vay-thanh-cong-xstu"
            element={<ThankYouPLXSSuccessXSTU />}
          />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
